import {
  getApprovalActionTotals,
  getSelectedProjectCounts,
} from '../../../helpers/approval-selection-counts.helper';
import { formatHours } from '../../../helpers/format-time-track.helper';
import {
  ApprovalConfirmMode,
  ApprovalSelectedProject,
} from '../../../types/time-tracking-approvals';
import {
  ApprovalConfirmCard,
  ApprovalConfirmCardHeader,
  ApprovedHoursSplitRows,
  ProjectColorDot,
  ProjectMetaRow,
  TranslateFn,
} from './approval-confirm-card';

interface SelectedProjectCardProps {
  selectedProject: ApprovalSelectedProject;
  mode: ApprovalConfirmMode;
  dateRange: string;
  ns: string;
  t: TranslateFn;
}

/**
 * Card for a project selected via its row checkbox (project-level approval).
 * Shows what the ACTION covers: approved hours (split invoice / bill) and entries to approve
 * (pending) or to unapprove (approved), net of any exclusions the user unchecked underneath.
 */
export function SelectedProjectCard({
  selectedProject,
  mode,
  dateRange,
  ns,
  t,
}: SelectedProjectCardProps) {
  const { project } = selectedProject;
  const { count: actionCount, hours: actionHours } = getApprovalActionTotals(
    getSelectedProjectCounts(selectedProject),
    mode
  );

  return (
    <ApprovalConfirmCard>
      <ApprovalConfirmCardHeader
        marker={<ProjectColorDot color={project.project.colorHex} />}
        name={project.project.projectName}
      />
      <div className="flex flex-col gap-1.5">
        <ProjectMetaRow label={t(`${ns}.projectCard.dateRange` as Parameters<typeof t>[0])}>
          {dateRange}
        </ProjectMetaRow>
        <ProjectMetaRow label={t(`${ns}.projectCard.totalHours` as Parameters<typeof t>[0])}>
          {formatHours(project.trackedHours)}
        </ProjectMetaRow>
        <ApprovedHoursSplitRows hours={actionHours} ns={ns} t={t} />
        <ProjectMetaRow label={t(`${ns}.projectCard.actionEntries` as Parameters<typeof t>[0])}>
          {actionCount}
        </ProjectMetaRow>
      </div>
    </ApprovalConfirmCard>
  );
}
